import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Paste(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M18 11.111V10c0-2.828 0-4.243-.879-5.121C16.243 4 14.828 4 12 4s-4.243 0-5.121.879C6 5.757 6 7.172 6 10v4c0 2.828 0 4.243.879 5.121C7.757 20 9.172 20 12 20M17 14v6M20 18l-2.894 2.894a.15.15 0 0 1-.212 0L14 18" }) }) });
}
const Paste = forwardRef(_Paste);
export { Paste };
